import React, { useState, useEffect,useRef } from "react";
//import "./Comment.css"; // Make sure this file is imported

const CommentForm = ({ postId }) => {
const turnstileRef = useRef(null);
useEffect(() => {
  // Inject Turnstile script
  const script = document.createElement("script");
  script.src = "https://challenges.cloudflare.com/turnstile/v0/api.js";
  script.async = true;
  script.defer = true;

  script.onload = () => {
    if (window.turnstile && turnstileRef.current) {
      window.turnstile.render(turnstileRef.current, {
        sitekey: "0x4AAAAAABfy-ox3gLsAborN", // <-- replace with your real site key
        callback: (token) => {
           setFormData((prev) => ({ ...prev, turnstile_token: token }));
        },
      });
    }
  };

  document.body.appendChild(script);

  return () => {
    document.body.removeChild(script);
  };
}, []);

  const [formData, setFormData] = useState({
    author: "",
    email: "",
    content: "",
    url: "", // Honeypot
    turnstile_token: "",
  });

  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState(null);
  const [error, setError] = useState(null);

  // Load Turnstile script
  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://challenges.cloudflare.com/turnstile/v0/api.js";
    script.async = true;
    script.defer = true;
    document.body.appendChild(script);

    window.turnstileCallback = (token) => {
      setFormData((prev) => ({ ...prev, turnstile_token: token }));
    };

    return () => {
      document.body.removeChild(script);
    };
  }, []);
  const MAX_WORDS = 100;
  const [content, setContent] = useState("");
  const [wordCount, setWordCount] = useState(0)
  const handleChange = (e) => {
    const text = e.target.value;
    //const words = text.trim().split(/\s+/);
    if (text.length <= MAX_WORDS) {
      setFormData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
      setContent(text);
      setWordCount(text.length);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage(null);
    setError(null);

    try {
      const res = await fetch(
        `https://app.reciteontv.com/wp-json/vvt/v1/views/${postId}/comment`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formData),
        }
      );

      const result = await res.json();

      if (!res.ok) {
        setError(result.message || "Something went wrong.");
      } else {
        setMessage(result.message || "Comment submitted successfully.");
        setFormData({
          author: "",
          email: "",
          content: "",
          url: "",
          turnstile_token: "",
        });
        setContent("");
        setWordCount(0);
        window.turnstile?.reset();
      }
    } catch (err) {
      setError("Network error or server not responding.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="comment-form-container">
    <h3 className="form-title">Leave a Comment!</h3>
    {message && <div className="form-message">{message}</div>}
    {error && <p style={{ color: "red" }}>{error}</p>}
    <form onSubmit={handleSubmit} className="comment-form">
      <input
        type="text"
        name="author"
        placeholder="Your Name"
        value={formData.author}
        onChange={handleChange}
        required
        className="input-field"
      />
      <br />
      <input
        type="email"
        name="email"
        placeholder="Your Email"
        value={formData.email}
        onChange={handleChange}
        required
        className="input-field"
      />
      <br />
      <textarea
        name="content"
        /*value={content}*/
        placeholder={`Write your comment (max ${MAX_WORDS} words)`}
        value={formData.content}
        onChange={handleChange}
        required
        className="textarea-field"
      />
   

      {/* Honeypot field (invisible to real users) */}
      <input
        type="text"
        name="url"
        style={{ display: "none" }}
        value={formData.url}
        onChange={handleChange}
      />
      <div className="word-count">{wordCount}/{MAX_WORDS} characters</div>
      {/* Turnstile CAPTCHA */}
       <div ref={turnstileRef}></div>

      <br />
      <button type="submit" disabled={loading} className="submit-button">
        {loading ? "Submitting..." : "Post Comment"}
      </button>
    </form>
    </div>
  );
};

export default CommentForm;
